import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
// import CoScholacticSidebar2025 from '../CoScholacticSidebar2025';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2025 from '../CoScholacticSidebar2025';


const FlamelessCooking2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/1.webp`;
const p2 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/2.webp`;
const p3 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/3.webp`;
const p4 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/4.webp`;
const p5 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/5.webp`;
const p6 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/6.webp`;
const p7 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/7.webp`;
const p8 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/8.webp`;
const p9 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/9.webp`;
const p10 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/10.webp`;
const p11 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/11.webp`;
const p12 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/12.webp`;
const p13 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/13.webp`;
const p14 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/14.webp`;
const p15 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/15.webp`;
const p16 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/16.webp`;
const p17 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Flame/17.webp`;



  

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
},
{
    src: p14,
    source: p14,
    rows: 1,
    cols: 1,
},
{
    src: p15,
    source: p15,
    rows: 1,
    cols: 1,
},
{
    src: p16,
    source: p16,
    rows: 1,
    cols: 1,
},
{
    src: p17,
    source: p17,
    rows: 1,
    cols: 1,
}




  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      FLAMELESS COOKING
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: 6-8     Date: 13 March 2026

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Tell me and I forget, teach me and I may remember, involve me and I learn. – Benjamin Franklin”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The students of National Public School Yeshwanthpur enthusiastically participated in a Fireless Cooking Activity conducted for the middle school grades in March 2026. The initiative aimed to foster creativity, encourage healthy eating habits and raise awareness about preparing nutritious food without the use of fire.
        <br></br>
        The activity was organised over three days for different grades. Class 6 students showcased their dishes on Friday, 07 March 2026, followed by Class 7 on Monday, 09 March 2026 and Class 8 on Wednesday, 11 March 2026.
        <br></br>
        Working in teams, students prepared a delightful range of healthy dishes, including fruit salads, sandwiches, sprouts chaat, bhel puri, yogurt-based snacks and imaginative desserts. The activity provided an opportunity for students to demonstrate innovation while keeping in mind the importance of nutrition, hygiene and presentation. 
        <br></br>
        Participants displayed remarkable enthusiasm and creativity in presenting their dishes and explaining the ingredients used. The teachers cherished and appreciated the students’ efforts and dedication in preparing visually appealing and nutritious dishes, applauding their creations for the taste, nutritional value, presentation skills and creativity.
        <br></br>
        The event not only enabled students to develop essential life skills but also reinforced the importance of healthy eating and teamwork. Overall, the Fireless Cooking Activity proved to be an enjoyable and enriching experience for the students of Classes 6, 7 and 8, making it a truly memorable and successful event.
        <br></br>

        </Typography>
      </Box>    
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Science is organised knowledge. Wisdom is organised life.”


<br/>
        </Typography> */}

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 250 : 350}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default FlamelessCooking2025;